<template>
  <div class="ushk-chart__item">
    <div class="ushk-chart__h">{{ name }}</div>
    <div class="ushk-chart__b">
      <div ref="chartBody" :class="{'is-empty': isEmpty}"></div>
    </div>
  </div>
</template>
<script>
  import { fetch } from '@/commons/fetch'
  import { addScript, dateFormat } from '@/commons/utils'
  export default {
    name: '',
    props: {
      name: String,
      code: String
    },
    data () {
      return {
        isLoading: false,
        isEmpty: true
      }
    },
    created () {
      this.render()
      setInterval(() => {
        this.render()
      }, 30000)
    },
    methods: {
      render () {
        this.getData().then((datas) => {
          this.creatChart(datas)
        })
      },
      getData () {
        return new Promise((resolve, reject) => {
          this.isLoading = true
          fetch({
            url: '//chart.jin10.com/baojia.php',
            params: {
              type: this.code
            },
            showError: false,
            type: 'jsonp',
            jsonpCallback: 'jsonpcallback',
            callback: (res) => {
              this.isLoading = false
              let datas = []
              let l = res && res.length
              if (!l) {
                return false
              }
              this.isEmpty = false
              for (var i = 0; i < l; i++) {
                datas.push({
                  name: res[i][0],
                  value: res[i]
                })
              }
              resolve(datas)
            },
            error: () => {
              this.isLoading = false
            }
          })
        })
      },
      creatChart (datas) {
        const option = {
          grid: {
            top: '5%',
            left: '0%',
            width: '80%',
            height: '90%',
            show: true,
            backgroundColor: '#fff'
          },
          title: {
            show: false
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              lineStyle: {
                width: 0
              }
            },
            backgroundColor: 'rgba(244,244,244, 0.8)',
            padding: [5, 10],
            formatter: function (params) {
              var value = params[0].value
              return '<div class="ushk-chart-tips"><div class="ushk-chart-tips__num">当前价格：<span>' + value[1] + '</span></div><div class="ushk-chart-tips__time">' + dateFormat(new Date(value[0]), 'yyyy-MM-dd hh:mm') + '</div></div>'
            }
          },
          xAxis: {
            type: 'time',
            boundaryGap: true,
            splitLine: {
              show: true,
              interval: 'auto',
              lineStyle: {
                color: ['#f1f1f1']
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#d4d1d2'
              }
            },
            axisLabel: {
              show: false
            }
          },
          yAxis: {
            type: 'value',
            position: 'right',
            scale: true,
            boundaryGap: true,
            splitLine: {
              lineStyle: {
                color: ['#f1f1f1']
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#d4d1d2'
              }
            },
            axisLabel: {
              margin: 10,

              textStyle: {
                fontSize: 12
              }
            }
          },
          series: [{
            name: '当前价格',
            type: 'line',
            showSymbol: false,
            itemStyle: {
              normal: {
                color: '#f45b42'
              }
            },
            lineStyle: {
              normal: {
                width: 1
              }
            },
            animation: false,
            animationDuration: 200,
            data: datas
          }]
        }
        const init = () => {
          const chart = echarts.init(this.$refs.chartBody)
          chart.setOption(option)
        }
        if (typeof echarts === 'undefined') {
          addScript('//cdn.jin10.com/assets/js/plugins/echarts/echarts3.min.js?20170506', () => {
            init()
          })
        } else {
          init()
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Chart.vue?4117681a